import React, {useState} from "react";
import clsx from "clsx";
import classes from "../RollStandDeviceView.module.scss";
import HeatMap from "./HeatMap";
import RollerDiagram from "./RollerDiagram";
import {useHistory} from "react-router-dom";


const RollStandDeviceView = ({ ws_data }) => {
     const [selectedSensors] = useState([]);
    const history = useHistory();


    const handleSensorGraphRedirectClick = (groupsId,sensorId) => {
            history.push(`/graphs/${groupsId}/${sensorId}`);
            return;
        }

        return (

                <div className={classes.fleetBar}>


                   {ws_data && ws_data?.groups?.map((item, index) => {

                       if(item.sensors != null) {
                           const isWarningGroup = item.sensors?.some((sensor) => sensor.Status === "WARNING");
                           return (
                               <div className={clsx(classes.tile, isWarningGroup && classes.hasWarningSensor)}
                                    key={item.Name ?? index}>
                                   <div className={classes.tileLabel}>{item.Name}</div>
                                   <RollerDiagram groupId={item.Id} sensors={item.sensors} onSensorClick={handleSensorGraphRedirectClick}
                                                  selectedSensors={selectedSensors}/>
                                   <div className={classes.tileBody}>
                                       <HeatMap  groupId={item.Id} sensors={item.sensors} onSensorClick={handleSensorGraphRedirectClick}
                                                selectedSensors={selectedSensors}/>
                                   </div>
                               </div>
                           );
                       }
                   })
                   }


                </div>

        );
}
export default RollStandDeviceView;